export const addReportFormFields =  [
    {
        order: 0,
        rowClass: "row",

        name: "row-10",
        fields: [
            {
                order: 0,
                name: "report-config-form-section-common",
                value:
                    "Wypełnij poniższe pola, aby dodać nowy raport. Pola oznaczone gwiazdką są wymagane.",
                type: "section",
                label: "",
                required: false,
                colClass: "col",
            },
        ],
    },
    {
        order: 0,
        rowClass: "row",
        name: "row-0",
        fields: [
            {
                order: 0,
                name: "name", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Nazwa raportu",
                required: true,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 100, // used only to validate text fields
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz nazwę raportu",
                helpText:
                    "Uzupełnij nazwę raportu. Pole musi zawierać od 3 do 100 znaków",
                colClass: "col",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-1",
        fields: [
            {
                order: 0,
                name: "description", // name is also a key in JSON
                value: "",
                type: "textarea", // available types: text, number, date, checkbox, select, list and button
                label: null,
                required: false,
                options: [], // for select type
                minLength: 0, // used only to validate text fields
                maxLength: 250, // used only to validate text fields
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Dodaj opis raportu (opcjonalne)",
                helpText:
                    "Możesz dodać opis raportu. Pole musi zawierać od 0 do 250 znaków",
                colClass: "col",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-2",
        fields: [
            {
                order: 0,
                name: "type", // name is also a key in JSON
                value: null,
                type: "select", // available types: text, number, date, checkbox, select, list and button
                label: "Typ raportu",
                required: true,
                options: ["SOP"], // for select type
                placeholder: "Wybierz typ raportu",
                helpText: "Wybierz z listy możliwych typów",
                colClass: "col col-lg-6",
            },
            {
                order: 0,
                name: "creator", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Autor",
                required: true,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 100, // used only to validate text fields
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz autora raportu",
                helpText: "Pole musi zawierać od 3 do 100 znaków",
                colClass: "col col-lg-6",
            },
        ],
    },
    {
        order: 0,
        rowClass: "row",
        name: "row-3",
        fields: [
            {
                order: 0,
                name: "cron", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Automatyczna aktualizacja (CRON)",
                required: true,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 100, // used only to validate text fields
                pattern:
                    "^(?#second)(\\*|(?:\\*|(?:[0-9]|(?:[1-5][0-9])))\\/(?:[0-9]|(?:[1-5][0-9]))|\n" +
                    "(?:[0-9]|(?:[1-5][0-9]))(?:(?:\\-[0-9]|\\-(?:[1-5][0-9]))?|(?:\\,(?:[0-9]|(?:[1-5][0-9])))*)) \n" +
                    "(?#minute)(\\*|(?:\\*|(?:[0-9]|(?:[1-5][0-9])))\\/(?:[0-9]|(?:[1-5][0-9]))|(?:[0-9]|\n" +
                    "(?:[1-5][0-9]))(?:(?:\\-[0-9]|\\-(?:[1-5][0-9]))?|(?:\\,(?:[0-9]|(?:[1-5][0-9])))*)) \n" +
                    "(?#hour)(\\*|(?:\\*|(?:\\*|(?:[0-9]|1[0-9]|2[0-3])))\\/(?:[0-9]|1[0-9]|2[0-3])|\n" +
                    "(?:[0-9]|1[0-9]|2[0-3])(?:(?:\\-(?:[0-9]|1[0-9]|2[0-3]))?|(?:\\,(?:[0-9]|1[0-9]|2[0-3]))*)) \n" +
                    "(?#day_of_month)(\\*|\\?|L(?:W|\\-(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:[1-9]|(?:[12][0-9])|\n" +
                    "3[01])(?:W|\\/(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:[1-9]|(?:[12][0-9])|3[01])\n" +
                    "(?:(?:\\-(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:\\,(?:[1-9]|(?:[12][0-9])|3[01]))*)) \n" +
                    "(?#month)(\\*|(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\n" +
                    "(?:(?:\\-(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?|\n" +
                    "(?:\\,(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))*)) \n" +
                    "(?#day_of_week)(\\*|\\?|[0-6](?:L|\\#[1-5])?|(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT)\n" +
                    "(?:(?:\\-(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))?|(?:\\,(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))*)) \n" +
                    "(?#year)(\\*|(?:[1-9][0-9]{3})(?:(?:\\-[1-9][0-9]{3})?|(?:\\,[1-9][0-9]{3})*))$",
                placeholder: "Wpisz wyrażenie CRON",
                helpText: "Pole musi byc zgodne ze specyfikacją CRON",
                colClass: "col col-lg-6",
            },
            {
                order: 0,
                name: "isCentral", // name is also a key in JSON
                value: false,
                type: "checkbox", // available types: text, number, date, checkbox, select,file, list and button
                label: "Czy raport ma być centralny",
                required: false,
                options: [], // for select type
                placeholder: "",
                helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                colClass: "col col-lg-3",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-4",
        fields: [
            {
                order: 0,
                name: "report-config-form-section-settings", // name is also a key in JSON
                value:
                    "Dodaj specyficzne ustawienia dla tego raportu. Wszystkie ustawienia są opcjonalne. Nie uzupełnienie ich jedanak spowoduje, iż ustawienia związane z konkretnym typem raportu zostaną domyślne. Zapoznaj się ze specyfikacją konkretnych typów raportów aby dowiedziec się jakie ustawienia są brane pod uwagę.",
                type: "section", // available types: text, number, date, checkbox, select, list and button
                label: "Ustawienia sekcji",
                required: false,
                pattern: "",
                placeholder: "",
                helpText: "",
                colClass: "col",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-5",
        fields: [
            {
                order: 0,
                name: "settings", // name is also a key in JSON
                value: null,
                type: "key-value-list", // available types: text, number, date, checkbox, select, list and button
                label: null,
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 100, // used only to validate text fields
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz nazwę ustawienia raportu, aby je dodać",
                helpText:
                    "Uzupełnij ustawieniaraportu. Pole musi zawierać od 3 do 100 znaków",
                colClass: "col",
            },
        ],
    },
]
